import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  const renderTableByLevel = () => {
    return (
      <>
        <thead>
          <tr>
            <th>No.</th>
            {currentLevel == UserLevel.National && <th>Provinsi</th>}
            {(currentLevel == UserLevel.Province ||
              currentLevel == UserLevel.National) && <th>Kabupaten</th>}
            {currentLevel == UserLevel.District && <th>Fasyankes</th>}
            <th>Jumlah uji silang yang dilakukan</th>
            <th>Jumlah bimtek yang dilakukan</th>
            <th>Jumlah profisiensi yang dilakukan</th>
            <th>Jumlah kegiatan PME yang dilakukan</th>
          </tr>
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {currentLevel == UserLevel.National && (
                  <th>{item?.province_name}</th>
                )}
                {(currentLevel == UserLevel.Province ||
                  currentLevel == UserLevel.National) && <th>{item?.name}</th>}
                {currentLevel == UserLevel.District && <th>{item?.name}</th>}

                <td>{item?.total_cross_check}</td>
                <td>{item?.total_bimtek}</td>
                <td>{item?.total_proficiency}</td>
                <td>{item?.total_pme}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>Laporan PME Tahunan</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {periodeName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode?.year}
            </th>
          </tr>
          {reportInfo?.statusPeriode === "monthly" && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                Bulan
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
              </th>
            </tr>
          )}
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Kab/Kota</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
